var path = 'components/reports/tooltips/reportTemplatesNetworksNames.html';
var html = "<div style=max-height:100px;overflow-x:auto><div ng-repeat=\"value in template.networks | orderBy\" ng-bind=value.name></div></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;